import React from 'react';
import { useSubscription } from '../../hooks/useSubscription';

// Displays the current plan as a small pill overlay. Non-clickable.
// Meant to be positioned inside a relatively positioned container.
function SubscriptionBadge({ style = {} }) {
  const subscription = useSubscription();

  if (!subscription?.hasSubscription()) {
    return null;
  }

  const planName = subscription.getPlanDisplayName() || subscription.getPlanName() || 'Unknown';
  const isActive = subscription.getStatus() === 'active';

  if (!isActive) {
    return null;
  }

  const overlayStyle = {
    position: 'absolute',
    left: '62%',
    transform: 'translateX(-50%)',
    bottom: 9,
    padding: '3px 8px',
    borderRadius: 999,
    fontSize: '10px',
    fontWeight: 600,
    background: '#001f1f',
    color: '#ffffff',
    border: '1px solid rgba(255,255,255,0.06)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
    cursor: 'default',
    whiteSpace: 'nowrap',
    lineHeight: 1,
    zIndex: 1,
    display: 'inline-block',
    width: 80,
    textAlign: 'center',
    ...style,
  };

  return <span data-testid="subscription-badge" style={overlayStyle}>{planName}</span>;
}

export default SubscriptionBadge;

